import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { SettingsProposalStepsFormComponent } from '../../../components/settings-proposal-steps-form/settings-proposal-steps-form.component';

@Component({
  selector: 'app-proposal-steps-edit-page',
  imports: [SettingsProposalStepsFormComponent],
  templateUrl: './proposal-steps-edit-page.component.html',
  styleUrl: './proposal-steps-edit-page.component.scss'
})
export class ProposalStepsEditPageComponent {
 proposalStepId!: number
  proposalStep?: any;

  constructor(
    private route: ActivatedRoute,
    private proposalsService: ProposalsService,
  ) {
  }

  ngOnInit(): void {
    this.proposalStepId = Number(this.route.snapshot.paramMap.get('proposalStepId'));
    if (this.proposalStepId) {
      this.loadData(this.proposalStepId);
    }
  }

  loadData(proposalStepId: any) {
    this.proposalsService.detailSettingsProposalSteps(proposalStepId).subscribe((response: any) => {
      this.proposalStep = response.data?.proposalStep;
    });

  }
}
